export const BRAND_NAME = 'Lotusexccom';
// Note: It is the main site url. Ex - quickexch.com, etc.
export const BRAND_DOMAIN = 'quickexch.com';
// Note: It is the hostname. Ex - pay-lotus.quickexch.com, lotus.quickexch.com, etc.
export const BRAND_DOMAIN_SKIN_URL = 'lotusexc.com';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const OPERATORID = 'HypexDemo';
export const BACKEND_DOMAIN = 'cue88.com';
